var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import v4 from 'uuid/v4';
var AttributeLevelsList = /** @class */ (function (_super) {
    __extends(AttributeLevelsList, _super);
    function AttributeLevelsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.attributeLevels = new Map();
        return _this;
    }
    AttributeLevelsList.prototype.mounted = function () {
        this.attributeLevels = this.value;
    };
    AttributeLevelsList.prototype.addItem = function () {
        var newKey = v4();
        this.attributeLevels.set(newKey, '');
        this.$emit('input', new Map(this.attributeLevels));
    };
    AttributeLevelsList.prototype.handleUserInput = function (index, event) {
        var value = event.currentTarget.value;
        (this.attributeLevels = new Map(this.value)).set(index, value);
        this.$emit('input', new Map(this.attributeLevels));
        this.validationProvider[Array.from(this.attributeLevels.keys()).indexOf(index)].validate(value);
    };
    AttributeLevelsList.prototype.handleDelete = function (key) {
        if (this.attributeLevels.size === 1) {
            return;
        }
        this.attributeLevels.delete(key);
        this.$emit('input', new Map(this.attributeLevels));
    };
    AttributeLevelsList.prototype.handleValueChange = function () {
        if (this.value != this.attributeLevels) {
            this.attributeLevels = new Map(this.value);
        }
    };
    var _a, _b;
    __decorate([
        Prop({ default: function () { return new Map(); } }),
        __metadata("design:type", typeof (_a = typeof Map !== "undefined" && Map) === "function" ? _a : Object)
    ], AttributeLevelsList.prototype, "value", void 0);
    __decorate([
        Prop({ default: false, type: Boolean }),
        __metadata("design:type", Boolean)
    ], AttributeLevelsList.prototype, "editing", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_b = typeof InstanceType !== "undefined" && InstanceType) === "function" ? _b : Object)
    ], AttributeLevelsList.prototype, "validationProvider", void 0);
    __decorate([
        Watch('value'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AttributeLevelsList.prototype, "handleValueChange", null);
    AttributeLevelsList = __decorate([
        Component
    ], AttributeLevelsList);
    return AttributeLevelsList;
}(Vue));
export default AttributeLevelsList;
